import Icon from "@material-ui/core/Icon";
import React from "react";
import { noop } from "src/globalConsts";
import { IconName } from "../../../../../globalTypes";
import { IconListItem, IconName as StyledIconName } from "./styles";

export type SelectIconProps = {
  iconName: IconName;
  selectIcon: (iconName: IconName) => void;
};

const SelectIcon = ({ iconName, selectIcon }: SelectIconProps) => (
  <IconListItem
    role="menuitem"
    onClick={() => selectIcon(iconName)}
    key={iconName}
    onKeyDown={noop}
  >
    <Icon>{iconName}</Icon>
    <StyledIconName>{iconName}</StyledIconName>
  </IconListItem>
);

export default SelectIcon;
